const fixedPoint0 = {
  type: 'fixedPoint',
  precision: 0
};

const fixedPoint1 = {
  type: 'fixedPoint',
  precision: 1
};

const currency0 = {
  type: 'currency',
  precision: 0
};

export const columnSchema = [
  { width: 80, field: 'id', displayName: 'Task ID', type: 'number', fixed: true, showInColumnChooser: false },
  { width: 120, field: 'channel', displayName: 'Channel', type: 'string' },
  { width: 135, field: 'stage', displayName: 'Stage', type: 'string' },
  { width: 145, field: 'requestType', displayName: 'Request Type', type: 'string' },
  { width: 135, field: 'workstreamType', displayName: '(legacy) Workstream Type', type: 'string', visible: false },
  { width: 101, field: 'taskStatus', displayName: 'Task Status', type: 'string' },
  { width: 101, field: 'underwriteStatus', displayName: 'UW Status', type: 'string' },
  { width: 110, field: 'source', displayName: 'Source', type: 'string' },
  { width: 85, field: 'assetId', displayName: 'Asset ID', type: 'number' },
  { width: 92, field: 'asgPropID', displayName: 'PM ID', type: 'number' },
  { width: 145, field: 'createdOn', displayName: 'Imported On', type: 'datetime' },
  { width: 115, field: 'importName', displayName: 'List Name', type: 'string' },
  { width: 90, field: 'dueDate', displayName: 'Due Date', type: 'date', format: 'shortDate' },
  { width: 145, field: 'postAcquisitionLoadCompletedOn', displayName: 'Load Completed On', type: 'datetime' },
  { width: 116, field: 'assignedUser', displayName: 'Assigned User', type: 'string' },
  { width: 180, field: 'street', displayName: 'Street', tooltip: 'Street Address', type: 'string' },
  { width: 101, field: 'postAcquisitionValuationCreatedBy', displayName: 'UW User', type: 'string' },
  { width: 85, field: 'postAcquisitionValuationRent', displayName: 'UW Rent', type: 'number', format: currency0 },
  { width: 85, field: 'postAcquisitionValuationAfterRepairValue', displayName: 'UW ARV', type: 'number', format: currency0 },
  { width: 110, field: 'postAcquisitionValuationLotValue', displayName: 'UW Lot Value', type: 'number', format: currency0 },
  { width: 120, field: 'postAcquisitionValuationAsIsValue', displayName: 'UW As Is Value', type: 'number', format: currency0 },
  { width: 134, field: 'postAcquisitionValuationReducedRent', displayName: 'UW Reduced Rent', type: 'number', format: currency0 },
  { width: 134, field: 'postAcquisitionValuationReducedAfterRepairValue', displayName: 'UW Reduced ARV', type: 'number', format: currency0 },
  { width: 101, field: 'postAcquisitionValuationNotes', displayName: 'UW Notes', type: 'string' },  
  { width: 120, field: 'city', displayName: 'City', type: 'string' },
  { width: 70, field: 'state', displayName: 'State', type: 'string' },
  { width: 90, field: 'zipCode', displayName: 'Zip Code', type: 'string' },
  { width: 65, field: 'beds', displayName: 'Beds', type: 'number' },
  { width: 70, field: 'baths', displayName: 'Baths', type: 'number', format: fixedPoint1 },
  { width: 90, field: 'yearBuilt', displayName: 'Year Built', type: 'number' },
  { width: 103, field: 'sqft', displayName: 'Square Feet', type: 'number', format: fixedPoint0 },
  { width: 81, field: 'lotSize', displayName: 'Lot Size', type: 'number', format: fixedPoint0 },
  { width: 90, field: 'region', displayName: 'Amherst Region', type: 'string' },
  { width: 113, field: 'propertyType', displayName: 'Property Type', type: 'string' },
  { width: 180, field: 'notes', displayName: 'Notes', type: 'string' },
  { width: 89, field: 'importId', displayName: 'Import ID', type: 'number' },
  { width: 101, field: 'postAcquisitionLoadCreatedBy', displayName: 'Loaded By', type: 'string' },  
  { width: 101, field: 'modelRent', displayName: 'Model Rent', type: 'number', format: currency0 },
  { width: 101, field: 'modelArv', displayName: 'Model ARV', type: 'number', format: currency0 },
  { width: 107, field: 'normalAvm', displayName: 'AVM Normal', type: 'number', format: currency0 },  
  { width: 145, field: 'consumedOn', displayName: 'Consumed On', tooltip: 'REALMS Pull Date', type: 'datetime' }
];